import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyTyingTheKnot = loadable(() => import(/* webpackChunkName: "content/createwedding-tying-the-knot" */ './TyingTheKnot'), 'TyingTheKnot');
